import { Typography } from '@mui/material';

import Modal from 'components/Common/Modal';
import Button from 'components/Common/Button';
import { InfoModalProps } from 'types/modal';

const InfoModal = ({
    onClose,
    isOpen,
    title,
    description,
    loading,
    onConfirm,
    children,
    renderActions,
    hideActionButtons,
    contentAlign = 'center',
}: InfoModalProps) => {
    return isOpen ? (
        <Modal onClose={onClose} isOpen={isOpen} modalTitle={title} contentAlign={contentAlign}>
            <>
                {description ? (
                    <Typography sx={{ fontSize: { xs: 14, sm: 18 }, my: 2, color: '#1F2937', fontWeight: 400 }}>{description}</Typography>
                ) : null}
                {children}
                {!renderActions && !hideActionButtons && (
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', marginTop: 32 }}>
                        <Button onClick={onClose} width="45%" title="Cancel" />
                        <Button variant="contained" loading={loading} onClick={onConfirm} width="45%" title="Confirm" />
                    </div>
                )}
                {renderActions && renderActions()}
            </>
        </Modal>
    ) : null;
};
export default InfoModal;
